"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _color = require("color");

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WixColorUtils = {
    getDisabledStylesConsts: function getDisabledStylesConsts() {
        return {
            _default: true,
            siteTextPresets: { "Title": { "editorKey": "font_0", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "36px", "fontFamily": "impact", "value": "font:normal normal normal 36px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Menu": { "editorKey": "font_1", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "16px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 16px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Page-title": { "editorKey": "font_2", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "20px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 20px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Heading-XL": { "editorKey": "font_3", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "58px", "fontFamily": "impact", "value": "font:normal normal normal 58px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-L": { "editorKey": "font_4", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "54px", "fontFamily": "impact", "value": "font:normal normal normal 54px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-M": { "editorKey": "font_5", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "36px", "fontFamily": "impact", "value": "font:normal normal normal 36px/1.4em impact,impact-w01-2010,impact-w02-2010,impact-w10-2010,sans-serif;" }, "Heading-S": { "editorKey": "font_6", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "26px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 26px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-L": { "editorKey": "font_7", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "18px", "fontFamily": "helvetica-w01-bold", "value": "font:normal normal normal 18px/1.4em helvetica-w01-bold,helvetica-w02-bold,helvetica-lt-w10-bold,sans-serif;" }, "Body-M": { "editorKey": "font_8", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "16px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 16px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-S": { "editorKey": "font_9", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "14px", "fontFamily": "helvetica-w01-roman", "value": "font:normal normal normal 14px/1.4em helvetica-w01-roman,helvetica-w02-roman,helvetica-lt-w10-roman,sans-serif;" }, "Body-XS": { "editorKey": "font_10", "lineHeight": "1.4em", "style": "normal", "weight": "normal", "size": "10px", "fontFamily": "helvetica-w01-light", "value": "font:normal normal normal 10px/1.4em helvetica-w01-light,helvetica-w02-light,sans-serif;" } },
            siteColors: [{ "name": "color_1", "value": "#FFFFFF", "reference": "white/black" }, { "name": "color_2", "value": "#000000", "reference": "black/white" }, { "name": "color_3", "value": "#ED1C24", "reference": "primery-1" }, { "name": "color_4", "value": "#0088CB", "reference": "primery-2" }, { "name": "color_5", "value": "#FFCB05", "reference": "primery-3" }, { "name": "color_11", "value": "#FFFFFF", "reference": "color-1" }, { "name": "color_12", "value": "#CCCCCC", "reference": "color-2" }, { "name": "color_13", "value": "#999999", "reference": "color-3" }, { "name": "color_14", "value": "#535353", "reference": "color-4" }, { "name": "color_15", "value": "#222222", "reference": "color-5" }, { "name": "color_16", "value": "#FFEFBA", "reference": "color-6" }, { "name": "color_17", "value": "#FFE798", "reference": "color-7" }, { "name": "color_18", "value": "#FFCF30", "reference": "color-8" }, { "name": "color_19", "value": "#AA8A20", "reference": "color-9" }, { "name": "color_20", "value": "#554510", "reference": "color-10" }, { "name": "color_21", "value": "#B6E8E3", "reference": "color-11" }, { "name": "color_22", "value": "#8DD1CA", "reference": "color-12" }, { "name": "color_23", "value": "#41BAAE", "reference": "color-13" }, { "name": "color_24", "value": "#2B7C74", "reference": "color-14" }, { "name": "color_25", "value": "#163E3A", "reference": "color-15" }, { "name": "color_26", "value": "#F4C0AF", "reference": "color-16" }, { "name": "color_27", "value": "#E99F86", "reference": "color-17" }, { "name": "color_28", "value": "#DE5021", "reference": "color-18" }, { "name": "color_29", "value": "#943616", "reference": "color-19" }, { "name": "color_30", "value": "#4A1B0B", "reference": "color-20" }, { "name": "color_31", "value": "#FFDAAA", "reference": "color-21" }, { "name": "color_32", "value": "#FFC880", "reference": "color-22" }, { "name": "color_33", "value": "#FF9100", "reference": "color-23" }, { "name": "color_34", "value": "#AA6000", "reference": "color-24" }, { "name": "color_35", "value": "#553000", "reference": "color-25" }],
            styleParams: { fonts: {}, colors: {}, booleans: {}, numbers: {} },
            content: {}
        };
    },
    getFullColorStyles: function getFullColorStyles(_ref) {
        var colorStyles = _ref.colorStyles,
            siteColors = _ref.siteColors,
            defaults = _ref.defaults;

        var ret = {};

        // Fix color styles due to '.' to '-' conversion
        var fixedColorStyles = {};
        _lodash2.default.each(colorStyles, function (v, k) {
            return fixedColorStyles[k.replace(/\./g, '-')] = v;
        });

        var getFromFixed = function getFromFixed(key) {
            return (fixedColorStyles[key] || {}).value || (fixedColorStyles[key] || {}).rgba || fixedColorStyles[key];
        };

        // Helper functions
        // Basic definitions
        ret['white'] = '#FFFFFF';
        ret['black'] = '#000000';

        // Basic template colors
        _lodash2.default.each(['color-1', 'color-2', 'color-3', 'color-4', 'color-5', 'color-6', 'color-7', 'color-8', 'color-13', 'color-18'], function (key) {
            return ret[key] = getFromFixed(key) || _lodash2.default.find(siteColors, function (c) {
                return c.reference == key;
            }).value;
        });

        // Fix for a bug in a very specific template
        ret.background = (fixedColorStyles.background || {}).value || ret['color-1'] === '#FFFFFF' && ret['color-2'] === '#F4EFE1' ? ret['color-2'] : ret['color-1'];

        var working = _lodash2.default.clone(_lodash2.default.toPairs(defaults));
        while (working.length > 0) {
            var _working$shift = working.shift(),
                _working$shift2 = (0, _slicedToArray3.default)(_working$shift, 3),
                key = _working$shift2[0],
                defString = _working$shift2[1],
                _working$shift2$ = _working$shift2[2],
                tried = _working$shift2$ === undefined ? false : _working$shift2$;

            try {
                ret[key] = getFromFixed(key) || this.calcValueFromString({ str: defString, values: ret, whiteWhenNotFound: false });
            } catch (e) {
                if (e === 'unparsed') {
                    if (tried) {
                        throw new Error("[WixStylesColorUtils] Using unkown key as default for " + key + ".");
                    }
                    working.push([key, defString, true]);
                } else {
                    throw e;
                }
            }
        }

        return ret;
    },
    calcValueFromString: function calcValueFromString(_ref2) {
        var str = _ref2.str,
            values = _ref2.values,
            _ref2$whiteWhenNotFou = _ref2.whiteWhenNotFound,
            whiteWhenNotFound = _ref2$whiteWhenNotFou === undefined ? true : _ref2$whiteWhenNotFou;

        var functions = {
            'get': function get(key) {
                if (key.startsWith('"') && key.endsWith('"')) {
                    key = key.substr(1, key.length - 2);
                }

                key = key.replace(/\./g, '-');

                // Variables are defined in the css as color-xxx, but in the styles as xxx (for backwards compatibility).
                // So, we need to make sure to check for both
                var value = function () {
                    if (values[key]) return values[key];
                    if (key.startsWith('color-')) return values[key.substr(6)]; // support 'bbb' and 'color-bbb' for same variable
                }();

                if (value) return value;

                try {
                    // Try to parse the string as a color, return if successful.
                    return new _color2.default(key).rgbString();
                } catch (e) {
                    console.log("[WixStylesColorUtils] Wss key " + key + " probably not given a default value");
                    if (whiteWhenNotFound) {
                        return new _color2.default('#ffffff').rgbString();
                    } else {
                        throw 'unparsed';
                    }
                }
            },
            'opacity': function opacity(params) {
                var match = params.match(/^(.*),(.*)$/);
                var value = fromDefaultString(match[1]);
                var alpha = parseFloat(match[2]);
                return new _color2.default(value).clearer(1 - alpha).rgbString();
            },
            'join': function join(params) {

                if (params.startsWith('[') && params.endsWith(']')) {
                    params = params.substr(1, params.length - 2);
                }

                var tokenRegex = /\(([^(]*?)\)/;
                var m = null;

                while (m = params.match(tokenRegex)) {
                    var token = ("_<_" + m[1] + "_>_").replace(/,/g, '_|_');
                    params = params.replace(tokenRegex, token);
                }
                var arr = _lodash2.default.map(params.split(','), function (p) {
                    return p.replace(/_<_/g, '(').replace(/_>_/g, ')').replace(/_\|_/g, ',').trim();
                });

                var ret = _lodash2.default.reduce(arr, function (acc, color) {
                    var c = new _color2.default(fromDefaultString(color));
                    acc.red(acc.red() + c.red() * c.alpha());
                    acc.green(acc.green() + c.green() * c.alpha());
                    acc.blue(acc.blue() + c.blue() * c.alpha());
                    acc.alpha(acc.alpha() + c.alpha());
                    return acc;
                }, new _color2.default('rgba(0,0,0,0)'));

                return ret.rgbString();
            }
        };

        function fromDefaultString(str) {
            var match = str.match(/(\w*)\((.*)\)$/);
            if (!match) return functions['get'](str);
            return functions[match[1]](match[2]);
        }

        return fromDefaultString(str);
    }
};

exports.default = WixColorUtils;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/WixStylesColorUtils.js
// module id = 157
// module chunks = 0